<template>
  <div>
    <b-form-group :label="prepend">
      <b-form-select v-model="column.column_id" :required="isRequired" @change="emitChange">
        <option :value="null" :disabled="isRequired">{{defaultOptionText}}</option>
        <optgroup v-for="(category, categoryIndex) in filteredColumnSpecCategories" :key="categoryIndex" :label="category.name">
          <option v-for="(column, columnIndex) in category.columns" :value="column.id" :key="columnIndex">{{columnName(column)}}</option>
        </optgroup>
      </b-form-select>
    </b-form-group>
    <b-form-row v-if="hasOptions">
      <converter-column-options v-if="selectedColumnSpec != null && selectedColumnSpec.column_type === 'converter'" @change="emitChange"
                                :column="column" :columnSpec="selectedColumnSpec" :columnSpecCategories="columnSpecCategories"
                                :isAggregate="isAggregate" :isRequired="isRequired" :reportType="reportType" :report="report"></converter-column-options>
      <comparison-column-options v-if="selectedColumnSpec != null && selectedColumnSpec.column_type === 'comparison'" @change="emitChange"
                                :column="column" :columnSpec="selectedColumnSpec" :columnSpecCategories="columnSpecCategories"
                                :isAggregate="isAggregate" :isRequired="isRequired" :reportType="reportType" :report="report"></comparison-column-options>
      <add-column-options v-if="selectedColumnSpec != null && selectedColumnSpec.column_type === 'add'" @change="emitChange"
                                :column="column" :columnSpec="selectedColumnSpec" :columnSpecCategories="columnSpecCategories"
                                :isAggregate="isAggregate" :isRequired="isRequired" :reportType="reportType" :report="report"></add-column-options>
      <greater-lesser-column-options v-if="selectedColumnSpec != null && (selectedColumnSpec.column_type === 'greater' || selectedColumnSpec.column_type === 'lesser')"
                                @change="emitChange" :column="column" :columnSpec="selectedColumnSpec" :columnSpecCategories="columnSpecCategories"
                                :isAggregate="isAggregate" :isRequired="isRequired" :reportType="reportType" :report="report"></greater-lesser-column-options>
    </b-form-row>
  </div>
</template>

<script>
import _ from 'lodash'
import ConverterColumnOptions from '@/components/reports/ConverterColumnOptions'
import ComparisonColumnOptions from '@/components/reports/ComparisonColumnOptions'
import AddColumnOptions from '@/components/reports/AddColumnOptions'
import GreaterLesserColumnOptions from '@/components/reports/GreaterLesserColumnOptions'

export default {
  name: 'column-picker',
  props: ['column', 'columnSpecCategories', 'reportType', 'report', 'isRequired', 'defaultOptionText', 'isGrouping', 'isSubGrouping', 'isAggregate', 'prepend', 'allowedDataTypes'],
  components: { ConverterColumnOptions, ComparisonColumnOptions, AddColumnOptions, GreaterLesserColumnOptions },
  computed: {
    allColumnSpecsById () {
      var columns = {}
      this.columnSpecCategories.forEach((category) => {
        category.columns.forEach((column) => {
          columns[column.id] = column
        })
      })
      return columns
    },
    filteredColumnSpecCategories () {
      return this.filterColumnSpecCategories(this.isGrouping, this.isSubGrouping, this.isAggregate, this.allowedDataTypes)
    },
    selectedColumnSpec () {
      if (this.column.column_id != null) {
        return this.allColumnSpecsById[this.column.column_id]
      } else {
        return null
      }
    },
    hasOptions () {
      if (this.selectedColumnSpec == null) {
        return false
      }
      return ['converter', 'comparison', 'add', 'greater', 'lesser'].indexOf(this.selectedColumnSpec.column_type) !== -1
    }
  },
  watch: {
    'column.column_id' () {
      this.column.options = {}
      if (this.selectedColumnSpec != null) {
        if (this.selectedColumnSpec.column_type === 'converter') {
          this.column.sub_columns = [{ column_id: null, sub_columns: [], options: {} }]
        } else if (this.selectedColumnSpec.column_type === 'comparison' || this.selectedColumnSpec.column_type === 'add' || this.selectedColumnSpec.column_type === 'greater' || this.selectedColumnSpec.column_type === 'lesser') {
          this.column.sub_columns = [
            { column_id: null, sub_columns: [], options: {} },
            { column_id: null, sub_columns: [], options: {} }
          ]
        }
      }
      this.emitChange()
    }
  },
  mounted () {
  },
  methods: {
    columnName (column) {
      if (column.column_type === 'converter' || column.column_type === 'comparison' || column.column_type === 'add' || column.column_type === 'greater' || column.column_type === 'lesser') {
        return `${column.name}...`
      } else if (column.data_type === 'bool') {
        return `${column.name} (Y/N)`
      } else if (column.data_type === 'datetime') {
        return `${column.name} (date & time)`
      } else {
        return column.name
      }
    },
    filterColumnSpecCategories (isGrouping, isSubGrouping, isAggregate, dataTypes) {
      var categories = _.cloneDeep(this.columnSpecCategories)
      categories.forEach((category) => {
        category.columns = category.columns.filter((columnSpec) => {
          if (dataTypes != null && dataTypes.indexOf(columnSpec.data_type) === -1) {
            return false
          }
          if (isGrouping && (!columnSpec.can_group || columnSpec.groupable_report_types.indexOf(this.reportType) === -1)) {
            return false
          }
          if (isSubGrouping && !columnSpec.can_sub_group) {
            return false
          }
          // if (isAggregate) {
          //   return columnSpec.is_aggregate || columnSpec.column_type === ''
          // }
          if (isAggregate && columnSpec.aggregation === 'none') {
            if (this.report != null && this.report.group != null && this.report.group.length === 1) {
              if (columnSpec.id === this.report.group[0].column_id) {
                return true
              } else {
                return columnSpec.grouping_covariants != null && columnSpec.grouping_covariants.indexOf(this.report.group[0].column_id) !== -1
              }
            } else {
              return false
            }
          }
          if (!isAggregate && columnSpec.aggregation === 'aggregate') {
            return false
          }
          return true
        })
      })
      categories = categories.filter((category) => { return category.columns.length > 0 })
      return categories
    },
    emitChange () {
      this.$emit('change', this.column)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/ColumnPicker.vue